module.exports = __webpack_public_path__ + "static/img/no-product.0095493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/index-activity/no-product.png
// module id = 0ew1
// module chunks = 4